import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";

export class RegisterCompleteComponent implements IJSLComponent {

    public render(): IJSLVNode {
        return <section class="banner-area">
            <h3>Ihr Konto wurde erfolgreich erstellt</h3>
            <div style="padding: 1rem">
                <strong>ACHTUNG: </strong>
                Sie müssen zuerst von einem Administrator freigeschalten werden bevor Sie ihr Konto verwenden können.<br/>
                Bitte haben Sie etwas Geduld.
            </div>
            <button class="genric-btn" click={() => {location.reload(); }}>Zur Login Seite</button>
        </section>;
    }


}
